import { NgTemplateOutlet } from '@angular/common';
import type { SimpleChanges, TemplateRef } from '@angular/core';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  output,
  inject,
  input,
  ChangeDetectionStrategy,
} from '@angular/core';

import type { User } from '@core/account-types';
import { trackByProp } from '@core/common-legacy';
import { I18nService } from '@core/i18n-legacy';
import {
  AvatarComponent,
  ButtonLoadingDirective,
  HeadingComponent,
  IconButtonComponent,
  IconComponent,
  RtTooltip,
} from '@core/user-interface-legacy';
import type { RoleWithAdmins } from '@core/visibility-legacy';

@Component({
  selector: 'rt-team-members-item',
  templateUrl: 'team-members-item.component.html',
  styleUrls: ['./team-members-item.component.less'],
  imports: [
    AvatarComponent,
    ButtonLoadingDirective,
    HeadingComponent,
    IconButtonComponent,
    IconComponent,
    RtTooltip,
    NgTemplateOutlet,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    '[class.is-last]': 'isLast()',
  },
})
export class TeamMembersItemComponent {
  private readonly i18n = inject(I18nService);

  protected readonly cdRef = inject(ChangeDetectorRef);

  public readonly elRef = inject(ElementRef);

  public readonly removable = input<boolean>(false);
  public readonly collapsable = input<boolean>(false);
  public readonly isSimple = input<boolean>(false);
  public readonly isLast = input<boolean>(false);
  public readonly adminInRemove = input<number | null>(null);
  public readonly hasPadding = input<boolean>(false);
  public readonly hasManageSettingsButton = input<boolean>(false);
  public readonly hasNoBorderBottom = input<boolean>(false);
  public readonly hasCheckboxOffset = input<boolean>(false);
  public readonly roleDescription = input<string>('');
  public readonly isDisabled = input<boolean>(false);
  public readonly removeTooltipText = input<string>(
    this.i18n.translate('app.offer_assignments.remove_recruiter'),
  );
  public readonly headingSlotTemplate = input<TemplateRef<any> | null>(null);

  public removeFollower = output<User>();
  public goToManageRole = output<number>();
  public itemExpanded = output<void>();

  @Input() public admin: User | null = null;
  @Input() public roleWithAdmins: RoleWithAdmins | null = null;

  public trackById = trackByProp<{ id: number }>({ prop: 'id' });
  public expanded: boolean = false;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.roleWithAdmins && changes.roleWithAdmins.currentValue) {
      this.expanded = changes.roleWithAdmins.currentValue.expanded;
      this.cdRef.detectChanges();
    }
  }

  public toggleList(): void {
    this.expanded = !this.expanded;
    this.cdRef.detectChanges();
    if (this.expanded) this.itemExpanded.emit();
  }

  public trackByIndex(index: number, _: any): number {
    return index;
  }
}
